var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.path)?_c('v-img',{staticClass:"mx-auto",class:_vm.imgClass,attrs:{"max-width":_vm.maxWidth,"position":_vm.position,"src":("" + _vm.imageRoot + _vm.path)}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }